import { c as _c } from "react/compiler-runtime";
import MiniSearch from "minisearch";
import { useEffect } from "react";
import { useDeepCompareMemo } from "use-deep-compare";
type IdLike = string | number;
export function useSearchResults(query, items, indexableFields, idField) {
  const $ = _c(17);
  const resolvedIdField = (idField ?? ("_id" in (items[0] ?? {}) ? "_id" as K : "id" as K)) as K;
  let t0;
  let t1;
  if ($[0] !== indexableFields || $[1] !== resolvedIdField) {
    t0 = () => new MiniSearch({
      idField: String(resolvedIdField),
      fields: indexableFields.map(String),
      searchOptions: {
        prefix: true,
        fuzzy: 0.2
      },
      extractField: _temp
    });
    t1 = [indexableFields, resolvedIdField];
    $[0] = indexableFields;
    $[1] = resolvedIdField;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  const fuzzyMatcher = useDeepCompareMemo(t0, t1);
  let t2;
  let t3;
  if ($[4] !== fuzzyMatcher || $[5] !== items || $[6] !== resolvedIdField) {
    t2 = () => {
      fuzzyMatcher.addAll(items.filter(item => {
        const id = item[resolvedIdField] as IdLike | undefined;
        return id != null && !fuzzyMatcher.has(String(id));
      }));
    };
    t3 = [fuzzyMatcher, items, resolvedIdField];
    $[4] = fuzzyMatcher;
    $[5] = items;
    $[6] = resolvedIdField;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  if (!query) {
    return items;
  }
  let t4;
  if ($[9] !== fuzzyMatcher || $[10] !== items || $[11] !== query || $[12] !== resolvedIdField) {
    const found = fuzzyMatcher.search(query);
    let t5;
    if ($[14] !== items || $[15] !== resolvedIdField) {
      t5 = res => items.find(it => String(it[resolvedIdField] as IdLike | undefined) === String(res.id));
      $[14] = items;
      $[15] = resolvedIdField;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    t4 = found.map(t5).filter(Boolean);
    $[9] = fuzzyMatcher;
    $[10] = items;
    $[11] = query;
    $[12] = resolvedIdField;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4 as T[];
}
function _temp(document, fieldName) {
  const value = document[fieldName as keyof T];
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number") {
    return String(value);
  }
  return JSON.stringify(value);
}